export default __webpack_public_path__ + "static/media/watch finished.c94aface.jpg";